<script setup lang="ts">
import type { ReservationSummary } from '../reservation';
defineProps<{ reservation?: ReservationSummary }>();
</script>
<template>
  <p v-if="reservation" class="reservation" :class="{ review: reservation.reviewRequired }">
    <strong>Séjour Beds24 #{{ reservation.bookingId }}</strong
    ><br />
    {{ reservation.arrival }} → {{ reservation.departure }}<br />
    {{
      reservation.reviewRequired
        ? 'À vérifier par l’administrateur — séjour modifié ou lecture à renouveler.'
        : 'Rattachement confirmé'
    }}
  </p>
</template>
<style scoped>
.reservation {
  border-left: 4px solid #23834d;
  background: #effaf2;
  padding: 0.6rem;
  overflow-wrap: anywhere;
}
.review {
  border-left-color: #c58500;
  background: #fff1cc;
  color: #5a3600;
}
</style>
